import { lazy, Suspense, useState, useRef } from 'react'

import classnames from 'classnames'

import './emojiPicker.scss'

import Icons from 'common/components/icons'
import useClickOutside from 'common/hooks/useClickOutside'

const EmojiPickerPopup = lazy(() => import('./emojiPickerPopup'))

export interface Props {
  onSelect?: (emoji: string) => void
}

const EmojiPicker = ({ onSelect }: Props) => {
  const [show, setShow] = useState<boolean>(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  const toggleShow = () => setShow(value => !value)
  const onSelectEmoji = (emoji: string) => {
    onSelect && onSelect(emoji)
  }
  const onClickOutside = () => {
    setShow(false)
  }

  useClickOutside({ ref: wrapperRef, onClickOutside })

  return (
    <div ref={wrapperRef} className={classnames('emoji-picker', { show })}>
      <button className="toggle-btn" onClick={toggleShow}>
        <Icons prefix="far" iconName="laugh"/>
      </button>
      <Suspense fallback={null}>
        <EmojiPickerPopup onSelect={onSelectEmoji}/>
      </Suspense>
    </div>
  )
}

export default EmojiPicker
